import React from "react";
import { findAllSemesterEvent } from "../../_events/semester/find.event";
import { alertError } from "../../_utils/alerts";

export const useAllSemester = () => {

    const [data, setData] = React.useState([]);

    const loadData = () => {
        findAllSemesterEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData();
    }, []);

    return { data, loadData };
}